export default class CookieService {
    setCookie(name, value, relativeExpiryDays, domain) {
        const expireDate = new Date();
        expireDate.setDate(expireDate.getDate() + relativeExpiryDays);

        let cookieValue = encodeURIComponent(value);

        if (cookieValue.length > 4000) {
            cookieValue = cookieValue.slice(0, 4000);
        }

        if (relativeExpiryDays !== null) {
            cookieValue += `; expires=${expireDate.toUTCString()}; SameSite=None; Secure`;
        }

        if (domain) {
            cookieValue += `domain:${domain}`;
        }

        document.cookie = `${name}=${cookieValue}`;
    }

    getCookie(name) {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            let cookieName = cookies[i].substr(0, cookies[i].indexOf('='));
            let cookieValue = cookies[i].substr(cookies[i].indexOf('=') + 1);
            cookieName = cookieName.replace(/^\s+|\s+$/g, '');

            if (cookieName === name) {
                return unescape(cookieValue);
            }
        }
        return null;
    }

    deleteCookie(name) {
        const expireDate = new Date(0);
        document.cookie = `${name}=; expires=${expireDate.toUTCString()}`;
    }
}